import * as httpTool from '../http-tools'
import * as apiConst from '../api-const'
export default {
    
    login (params) {
        return httpTool.fetchPost(apiConst.loginUrl,params)
    }
}


// WEBPACK FOOTER //
// ./src/service/api/repository/login-api.js